//console.log("raycustom.js loaded!");
// RC 2025-09-16: This script makes it so that when you click a thumbnail on the product page it updates the color selector to the color of the thumbnail that you picked.. Stupid that isn't OOTB functionality. Ah well.

document.addEventListener("DOMContentLoaded", function () {
  if (!window.theme || !window.theme.productSingleObject) {
    console.warn("No product object found.");
    return;
  }

  const product = window.theme.productSingleObject;

  document.querySelectorAll(".product-single__thumbnail").forEach(thumbnail => {
    thumbnail.addEventListener("click", function () {
      const imageId = this.getAttribute("data-image-id");
      console.log("Thumbnail clicked, imageId:", imageId);

      const matchingVariant = product.variants.find(v => {
        return v.featured_image && v.featured_image.id == imageId;
      });

      if (matchingVariant) {
        console.log("Matching variant found:", matchingVariant.title);

        // Update Shopify hidden variant <select name="id">
        const variantSelect = document.querySelector("select[name='id']");
        if (variantSelect) {
          variantSelect.value = matchingVariant.id;
          variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // Update the visible Color dropdown
        const colorSelect = document.querySelector('select.single-option-selector[data-option="option1"]');
        if (colorSelect) {
          const colorValue = matchingVariant.option1;
          colorSelect.value = colorValue;
          colorSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
      } else {
        console.warn("No matching variant for imageId:", imageId);
      }
    });
  });
});
